import style from './MovieSubtitle.module.scss'
import { Button } from '@mui/material';
import SubtitleText from './subtitleText/SubtitleText';
import SubtitleVideo from './subtitleVideo/SubtitleVideo';
import SubtitleImg from './subtitleImg/SubtitleImg';
import SubtitleTorrents from './subtitleTorrents/SubtitleTorrents';
import SubtitleSimilar from './subtitleSimilar/SubtitleSimilar';
import React from 'react';



type MovieSubtitleProps = {
    yt_trailer: string
}

const MovieSubtitle: React.FC<MovieSubtitleProps> = ({ yt_trailer }) => {
    return (
        <div className={style.movie__subtitle}>
            <SubtitleText />
            <SubtitleVideo yt_trailer={yt_trailer} />
            <SubtitleImg />
            <SubtitleTorrents />
            <SubtitleSimilar />
        </div>
    )
}

export default MovieSubtitle;